/* eslint-disable */
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getBlCrAdiciones, getBlCrAdicion } from "../../services/BlCrAdicionService";
import Message from "../../utils/Message";
import BlCrAdicionDialog from "./BlCrAdicionDialog";
import { Add } from "@mui/icons-material";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const nameItemsText = "Adiciones de Block/Cristal";
//
// #############################################################################
//
const BlCrAdicionTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const { hasPermission } = useContext(AuthContext);
  const _crearBlCrAdicion = hasPermission("bl-cr-adicion-c");
  const _editarBlCrAdicion = hasPermission("bl-cr-adicion-e");
  const _habilitarBlCrAdicion = hasPermission("bl-cr-adicion-h");
  const _deshabilitarBlCrAdicion = hasPermission("bl-cr-adicion-d");

  const tableColumns = [
    {
      field: "valor",
      headerName: "Adición",
      headerAlign: "center",
      align: "center",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.valor;
        _val = _val.toFixed(2);
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarBlCrAdicion && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && _deshabilitarBlCrAdicion && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarBlCrAdicion && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setCurrentPage(0);
    setSearchData(initialSearchData);
    setItemsCrud([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getBlCrAdiciones(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    let _itemCrud = {};

    if (action !== "new") {
      const loadItem = async () => {
        setIsDoingSomething(true);
        const response = await getBlCrAdicion({ id: itemCrud.id });
        setIsDoingSomething(false);

        if (response.ok) {
          let _response = response.data.data[0];

          _itemCrud = {
            id: _response.id,
            valor: _response.valor,
            observaciones: _response.observaciones,
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setOpenDialog(true);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialog(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogSave = () => {
    load();
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-documento-select-label">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearBlCrAdicion && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nueva Adición de Block/Cristal">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nueva
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>
        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openDialog && (
        <BlCrAdicionDialog
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BlCrAdicionTable;
